import './EventTicket.css'; 
import ClassicButton from '../UI/ClassicButton/ClassicButton';
import { useState } from 'react';
import BookingModal from '../BookingModal/BookingModal';
import { IEventPageResponseModel } from '../../interfaces/responses/IEventPageResponseModel';

interface TicketProps {
    event: IEventPageResponseModel;
    ticketType: string;
    ticketPrice: number;
}

const EventTicket: React.FC<TicketProps> = ({ event, ticketType, ticketPrice }) => {
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>('');
    
    const handleBooking = () => {
        setModalVisible(!modalVisible);
    }
    
    const handleCloseModal = () => {
        setModalVisible(false);
    }
    
    const handlePaymentSuccess = () => {
        setAlertMessage('Оплата прошла успешно! Проверьте электронную почту.');
        setAlertVisible(true);
    };
    
    return (
        <>
            <div className='event_ticket'>
                <div className='event_ticket_content'>
                    <div className='event_ticket_contentBlock title'>
                            {event.title}
                    </div>

                    <div className='event_ticket_contentBlock'>
                        <p>Дата:</p>
                        <div>
                            {new Date(event.eventDate).toLocaleDateString('ru-RU', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            })}
                        </div>
                    </div>

                    <div className='event_ticket_contentBlock'>
                        <p>Время:</p>
                        <div>
                            {new Date(event.eventDate).toLocaleTimeString('ru-RU', {
                                hour: '2-digit',
                                minute: '2-digit'
                            })}
                        </div>
                    </div>

                    <div className='event_ticket_contentBlock location'>
                        <p>Пространство:</p>
                        <div>
                            {event.location}
                        </div>
                    </div>

                    <div className='event_ticket_contentBlock button'>
                        <ClassicButton
                            onClick={handleBooking}
                            fontSize='15px'
                            width='90%'
                            bgColor='#ffe5cc'
                            fontColor='#8E0606'
                            fontFamily='Actay Wide Bold'
                        >
                            Купить билет
                        </ClassicButton>
                    </div>
                </div>
            </div>
            
            <BookingModal 
                event={event} 
                мodalVisible={modalVisible} 
                setModalVisible={setModalVisible} 
                onCloseModal={handleCloseModal}
                onPaymentSuccess={handlePaymentSuccess}
            />
        </>
    );
};

export default EventTicket;